// var beURL = 'http://localhost:8080';
// var beURL = 'https://fiuturproof-backend-poc.dev.fiuturx.com';
var beURL = 'https://api.dev.fiuturx.com';
// var beURL = 'https://fiuturproof-backend.qa.fiuturx.com';
// var auth0_domain = 'https://xpansiv-dev.us.auth0.com';
// var auth0_clientid = 'PZdtAPhS9arC4WO8szwQ9nsGHUci3Cdr';
var auth0_domain = 'https://nonprod.auth.fiuturx.com';
var auth0_clientid = 'Qm8IYRPy2vDaXssuPGoXlT1Tzj9ZZV6C';

if (process.env.REACT_APP_BE_URL && process.env.REACT_APP_BE_URL!==undefined) {
    beURL = `${process.env.REACT_APP_BE_URL}`;
}
if (process.env.REACT_APP_AUTH0_DOMAIN && process.env.REACT_APP_AUTH0_DOMAIN!==undefined) {
    auth0_domain = `${process.env.REACT_APP_AUTH0_DOMAIN}`;
}
if (process.env.REACT_APP_AUTH0_CLIENTID && process.env.REACT_APP_AUTH0_CLIENTID!==undefined) {
    auth0_clientid = `${process.env.REACT_APP_AUTH0_CLIENTID}`;
}

const auth0_audience = beURL;

export { beURL, auth0_domain, auth0_clientid, auth0_audience };